<template>
  <div>
    <nav
      class="bg-gray-800 text-white flex items-center justify-between p-4 fixed top-0 left-0 w-full z-20"
    >
      <a href="/">
        <img
          src="/indagrobanner.jpg"
          alt="IndAgro"
          class="h-auto w-full max-w-[150px] rounded-sm sm:rounded-md"
        />
      </a>

      <!-- Menú md y lg -->
      <div class="hidden md:flex lg:flex space-x-4 mx-auto">
        <div class="group flex items-center space-x-2">
          <router-link
            to="/cotizaciones"
            class="py-2 px-4 rounded hover:bg-gray-900 group-hover:flex items-center"
            active-class="bg-gray-900"
          >
            <i class="fas fa-file-invoice mr-2"></i>
            <span class="hidden group-hover:inline">Cotizaciones</span>
          </router-link>
        </div>

        <div class="group flex items-center space-x-2">
          <router-link
            to="/ordenes_compra"
            class="py-2 px-4 rounded hover:bg-gray-900 group-hover:flex items-center"
            active-class="bg-gray-900"
          >
            <i class="fas fa-clipboard-list mr-2"></i>
            <span class="hidden group-hover:inline">Ordenes de compra</span>
          </router-link>
        </div>

        <div class="group flex items-center space-x-2">
          <router-link
            to="/products"
            class="py-2 px-4 rounded hover:bg-gray-900 group-hover:flex items-center"
            active-class="bg-gray-900"
          >
            <i class="fas fa-cogs mr-2"></i>
            <span class="hidden group-hover:inline">Productos y Servicios</span>
          </router-link>
        </div>

        <div class="group flex items-center space-x-2">
          <router-link
            to="/client"
            class="py-2 px-4 rounded hover:bg-gray-900 group-hover:flex items-center"
            active-class="bg-gray-900"
          >
            <i class="fas fa-users mr-2"></i>
            <span class="hidden group-hover:inline">Clientes</span>
          </router-link>
        </div>

        <div class="group flex items-center space-x-2">
          <router-link
            to="/provider"
            class="py-2 px-4 rounded hover:bg-gray-900 group-hover:flex items-center"
            active-class="bg-gray-900"
          >
            <i class="fas fa-truck mr-2"></i>
            <span class="hidden group-hover:inline">Proveedores</span>
          </router-link>
        </div>

        <div class="group flex items-center space-x-2" v-if="isAdmin">
          <router-link
            to="/users"
            class="py-2 px-4 rounded hover:bg-gray-900 group-hover:flex items-center"
            active-class="bg-gray-900"
          >
            <i class="fas fa-user mr-2"></i>
            <span class="hidden group-hover:inline">Usuarios</span>
          </router-link>
        </div>

        <div class="group flex items-center space-x-2">
          <router-link
            to="/information"
            class="py-2 px-4 rounded hover:bg-gray-900 group-hover:flex items-center"
            active-class="bg-gray-900"
          >
            <i class="fas fa-info-circle mr-2"></i>
            <span class="hidden group-hover:inline">Informacion</span>
          </router-link>
        </div>

        <div class="group flex items-center space-x-2">
          <router-link
            to="/notes"
            class="py-2 px-4 rounded hover:bg-gray-900 group-hover:flex items-center"
            active-class="bg-gray-900"
          >
            <i class="fas fa-sticky-note mr-2"></i>
            <span class="hidden group-hover:inline">Notas</span>
          </router-link>
        </div>

        <div class="group flex items-center space-x-2">
          <router-link
            to="/facturasProveedor"
            class="py-2 px-4 rounded hover:bg-gray-900 group-hover:flex items-center"
            active-class="bg-gray-900"
          >
            <i class="fas fa-file-invoice-dollar mr-2"></i>
            <span class="hidden group-hover:inline">Facturas Proveedor</span>
          </router-link>
        </div>

        <div class="group flex items-center space-x-2">
          <router-link
            to="/estadistica"
            class="py-2 px-4 rounded hover:bg-gray-900 group-hover:flex items-center"
            active-class="bg-gray-900"
          >
            <i class="fas fa-chart-line mr-2"></i>
            <span class="hidden group-hover:inline">Estadisticas</span>
          </router-link>
        </div>
      </div>

      <!-- Abrir/cerrar el menú lateral -->
      <button
        @click="toggleMenu"
        class="text-white p-2 rounded-md focus:outline-none md:hidden lg:hidden"
      >
        <svg
          v-if="!isMenuOpen"
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 6h16M4 12h16M4 18h16"
          />
        </svg>
        <svg
          v-else
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
      <!-- boton de cerrar sesion pero md y lg -->
      <button @click="openModal" class="hidden md:block">
        <i class="fas fa-sign-out-alt text-white"></i>
      </button>
    </nav>

    <!-- Menu lateral -->
    <nav
      :class="{ '-translate-x-full': !isMenuOpen, 'translate-x-0': isMenuOpen }"
      class="fixed inset-y-0 left-0 top-0 mt-16 w-64 bg-gray-800 text-white h-screen transform transition-transform duration-300 z-10 flex flex-col p-6 space-y-4 overflow-y-auto"
    >
      <div class="flex flex-col space-y-4">
        <router-link
          to="/cotizaciones"
          class="block py-2 px-4 rounded hover:bg-gray-900"
          active-class="bg-gray-900"
          @click="closeMenuOnMobile"
        >
          <i class="fas fa-file-invoice mr-2"></i>
          Cotizaciones
        </router-link>
        <router-link
          to="/ordenes_compra"
          class="block py-2 px-4 rounded hover:bg-gray-900"
          active-class="bg-gray-900"
          @click="closeMenuOnMobile"
        >
          <i class="fas fa-clipboard-list mr-2"></i>
          Ordenes de compra
        </router-link>
        <router-link
          to="/products"
          class="block py-2 px-4 rounded hover:bg-gray-900"
          active-class="bg-gray-900"
          @click="closeMenuOnMobile"
        >
          <i class="fas fa-cogs mr-2"></i>
          Productos y Servicios
        </router-link>
        <router-link
          to="/client"
          class="block py-2 px-4 rounded hover:bg-gray-900"
          active-class="bg-gray-900"
          @click="closeMenuOnMobile"
        >
          <i class="fas fa-users mr-2"></i>
          Clientes
        </router-link>
        <router-link
          to="/provider"
          class="block py-2 px-4 rounded hover:bg-gray-900"
          active-class="bg-gray-900"
          @click="closeMenuOnMobile"
        >
          <i class="fas fa-truck mr-2"></i>
          Proveedores
        </router-link>
        <div class="group flex items-center space-x-2" v-if="this.isAdmin">
        <router-link
          to="/users"
          class="block py-2 px-4 rounded hover:bg-gray-900"
          active-class="bg-gray-900"
          @click="closeMenuOnMobile"
        >
          <i class="fas fa-user mr-2"></i>
          Usuarios
        </router-link>
        </div>
        <router-link
          to="/information"
          class="block py-2 px-4 rounded hover:bg-gray-900"
          active-class="bg-gray-900"
          @click="closeMenuOnMobile"
        >
          <i class="fas fa-info-circle mr-2"></i>
          Informacion
        </router-link>
        <router-link
          to="/notes"
          class="block py-2 px-4 rounded hover:bg-gray-900"
          active-class="bg-gray-900"
          @click="closeMenuOnMobile"
        >
          <i class="fas fa-sticky-note mr-2"></i>
          Notas
        </router-link>
        <router-link
          to="/facturasProveedor"
          class="block py-2 px-4 rounded hover:bg-gray-900"
          active-class="bg-gray-900"
          @click="closeMenuOnMobile"
        >
          <i class="fas fa-file-invoice-dollar mr-2"></i>
          Facturas Proveedor
        </router-link>
        <router-link
          to="/estadistica"
          class="block py-2 px-4 rounded hover:bg-gray-900"
          active-class="bg-gray-900"
          @click="closeMenuOnMobile"
        >
          <i class="fas fa-chart-line mr-2"></i>
          Estadisticas
        </router-link>
      </div>
      <hr />
      <div class="bottom-0">
        <button
          @click="openModal"
          class="flex items-center px-4 py-2 text-gray-300"
        >
          <i class="fas fa-sign-out-alt mr-2"></i>
          Cerrar sesión
        </button>
      </div>
    </nav>

    <!-- Modal -->
    <div
      v-if="isModalOpen"
      class="fixed inset-0 bg-gray-500 bg-opacity-50 flex items-center justify-center z-30"
    >
      <div class="bg-gray-800 p-6 rounded-lg shadow-lg max-w-sm w-full">
        <h2 class="text-lg font-semibold mb-4 text-gray-300">
          ¿Estás seguro de cerrar sesión?
        </h2>
        <div class="flex justify-end space-x-4">
          <button
            @click="closeModal"
            type="button"
            class="py-2 px-3 text-sm font-medium rounded-lg border focus:ring-4 focus:outline-none focus:ring-primary-300 focus:z-10 bg-gray-700 text-gray-300 border-gray-500 hover:text-white hover:bg-gray-600 focus:ring-gray-600"
          >
            Cancelar
          </button>
          <button
            type="submit"
            @click="logout"
            class="py-2 px-3 text-sm font-medium text-center text-white rounded-lg focus:ring-4 focus:outline-none bg-red-500 hover:bg-red-600 focus:ring-red-900"
          >
            Cerrar sesión
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isMenuOpen: false,
      isModalOpen: false,
      isAdmin: false,
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
      this.$emit("toggleMenu");
    },
    closeMenuOnMobile() {
      if (window.innerWidth < 768) {
        this.isMenuOpen = false;
      }
    },
    openModal() {
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
    },
    logout() {
      this.$axios.delete('/logout').then(
        response => {
          alert(response.data.message);
          localStorage.removeItem('token');
          this.$router.push('/login');
        }).catch(error => {
          console.error('Error al iniciar sesión:', error.response);
          if (error.response.request.status) {
            localStorage.removeItem('token');
            this.$router.push('/login');
          }
          alert(error.response.data.message);
        });
    }
  },
  mounted(){
    this.$axios.get("/user").then(response => {
      if(response.data.usuario === 'admin')
        this.isAdmin = true;
    }).catch(() => {return});
  }
};
</script>
